<footer class="bg-white border-t border-gray-200 py-6">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex flex-col md:flex-row justify-between items-center">
      <div class="mb-4 md:mb-0">
        <p class="text-sm text-gray-500">© 2025 AirGateway. All rights reserved.</p>
      </div>
      <div class="flex space-x-6">
        <a
          href="https://support.airgateway.com/"
          target="_blank"
          class="text-gray-500 hover:text-primary"
        >
          <span class="text-sm">Help Center</span>
        </a>
        <a href="#" target="_blank" class="text-gray-500 hover:text-primary">
          <span class="text-sm">Privacy Policy</span>
        </a>
        <a
          href="https://airgateway.com/tos/"
          target="_blank"
          class="text-gray-500 hover:text-primary"
        >
          <span class="text-sm">Terms of Service</span>
        </a>
      </div>
    </div>
  </div>
</footer>
